<template>
  <el-scrollbar class="default-scrollbar" wrap-class="default-scrollbar__wrap"
                view-class="p20-scrollbar__view">
    <div v-if="loading">
      <el-tabs v-model="activeTab" style="margin-left: 30px;margin-right: 30px;margin-top: 20px">
        <!-- ========== 申请审核 ========== -->
        <el-tab-pane label="申请审核" name="apply">
          <el-form style="margin-top: 10px">
            <el-form-item>
              <el-select v-model="status" clearable placeholder="申请状态" @change="queryApply()">
                <el-option label="申请中" :value="1"></el-option>
                <el-option label="已认证" :value="2"></el-option>
                <el-option label="已拒绝" :value="3"></el-option>
              </el-select>
              <el-input v-model="searchForm" placeholder="请输入姓名/手机号" style="width:400px"
                        @keyup.enter.native="queryApply"
                        clearable></el-input>
              <el-button type="primary" @click="queryApply()">搜索</el-button>
              <el-button type="info" style="float: right" @click="guidePage=true">指引</el-button>
            </el-form-item>
          </el-form>

          <el-table
              border
              :header-cell-style="{background:'#dee2ec', color: '#666666'}"
              :cell-style="{'text-align':'center','border-right':'1px solid #eee','border-bottom':'1px solid #eee'}"
              :data="applyList"
              stripe
              max-height="650"
              style="width: 100%;margin-bottom:20px">
            <el-table-column prop="userName" label="用户"></el-table-column>
            <el-table-column prop="wechatPhone" label="手机号"></el-table-column>
            <el-table-column prop="orgName" label="机构名称"></el-table-column>
            <el-table-column prop="orgType" label="机构类型"></el-table-column>
            <el-table-column prop="contactName" label="联系人"></el-table-column>
            <el-table-column prop="contactPhone" label="联系电话"></el-table-column>
            <el-table-column prop="applyNote" label="申请备注"></el-table-column>
            <el-table-column prop="createTime" label="申请时间"></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">{{statusText(scope.row.status)}}</template>
            </el-table-column>
            <el-table-column prop="auditNote" label="审核意见"></el-table-column>
            <el-table-column prop="operation" label="操作" width="160">
              <template slot-scope="scope" v-if="scope.row.status===1">
                <el-button type="primary" size="medium" @click="approve(scope.row)">通过</el-button>
                <el-button type="danger" size="medium" @click="rejectButton(scope.row)">驳回</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="text-align: center"
                         background
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage"
                         :page-sizes="pagesizes"
                         :page-size="pagesize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="all">
          </el-pagination>
        </el-tab-pane>

        <!-- ========== 直接认证（线下合作机构直接开通，不走申请） ========== -->
        <el-tab-pane label="直接认证" name="direct">
          <el-form style="margin-top: 10px">
            <el-form-item>
              <el-input v-model="userSearch" placeholder="请输入姓名/手机号搜索用户" style="width:400px"
                        @keyup.enter.native="queryUserList"
                        clearable></el-input>
              <el-button type="primary" @click="queryUserList()">搜索</el-button>
            </el-form-item>
          </el-form>
          <el-table
              border
              :header-cell-style="{background:'#dee2ec', color: '#666666'}"
              :cell-style="{'text-align':'center','border-right':'1px solid #eee','border-bottom':'1px solid #eee'}"
              :data="userList"
              stripe
              max-height="650"
              style="width: 100%;margin-bottom:20px">
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="wechatPhone" label="手机号"></el-table-column>
            <el-table-column prop="nickName" label="昵称"></el-table-column>
            <el-table-column label="发起人状态">
              <template slot-scope="scope">{{statusText(scope.row.organizerStatus || 0)}}</template>
            </el-table-column>
            <el-table-column prop="operation" label="操作" width="220">
              <template slot-scope="scope">
                <el-button v-if="(scope.row.organizerStatus || 0) !== 2" type="primary" size="medium"
                           @click="setCertified(scope.row)">设为认证发起人</el-button>
                <el-button v-else type="danger" size="medium"
                           @click="cancelCertified(scope.row)">取消认证</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="text-align: center"
                         background
                         @size-change="handleUserSizeChange"
                         @current-change="handleUserCurrentChange"
                         :current-page="userCurrentPage"
                         :page-sizes="pagesizes"
                         :page-size="userPagesize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="userAll">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>

      <el-dialog title="驳回申请" :visible.sync="rejectPage" width="500px">
        <el-form label-width="100px">
          <el-form-item label="驳回原因" required>
            <el-input v-model="auditNote" type="textarea" placeholder="请填写驳回原因（必填）"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="rejectPage = false">取消</el-button>
          <el-button type="danger" @click="reject()">确认驳回</el-button>
        </div>
      </el-dialog>

      <el-dialog title="指引" :visible.sync="guidePage" width="1000px">
        <div>
          <h2>发起人管理（发起人权限一期）</h2>
          本页用于审核小程序用户提交的发起人申请，以及对线下谈好的合作机构直接开通认证。
          <br>
          <h3>申请审核：可按状态、用户姓名/手机号筛选；申请中的记录可点“通过”或“驳回”，驳回必须填原因。<br>
            直接认证：搜索用户后一键「设为认证发起人 / 取消认证」，全部留痕（操作人+时间）。<br>
            认证发起人发布活动免费（不扣咖值），且活动卡片带「认证主办方」角标；深度/专属服务会员发布维持原扣咖值规则。<br></h3>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="guidePage = false">关 闭</el-button>
        </div>
      </el-dialog>
    </div>
  </el-scrollbar>
</template>
<script>
import {organizerApplyList, organizerApplyAudit, organizerToggle, queryUser} from "@/common/js/index.js"

export default {
  name: "organizerApply",
  // 权限说明：发起人权限一期，仅超管可见（后端 notSuper 强制校验）
  data() {
    return {
      activeTab: 'apply',
      guidePage: false,
      applyList: [],
      status: '',
      searchForm: '',
      all: 0,
      currentPage: 1,
      loading: false,
      pagesize: 20,
      pagesizes: [10, 20, 30, 50, 100, 200, 300, 400, 500, 1000],
      rejectPage: false,
      rejectId: null,
      auditNote: '',
      // 直接认证
      userSearch: '',
      userList: [],
      userAll: 0,
      userCurrentPage: 1,
      userPagesize: 20,
    }
  },
  methods: {
    statusText(status) {
      if (status === 1) return '申请中'
      if (status === 2) return '已认证'
      if (status === 3) return '已拒绝'
      return '普通'
    },
    queryApply() {
      let subData = 'currPage=' + this.currentPage
          + '&pageSizePara=' + this.pagesize
          + '&userName=' + this.searchForm
      if (this.status !== '' && this.status !== null) {
        subData += '&status=' + this.status
      }
      organizerApplyList(subData).then(res => {
        if (res) {
          this.applyList = res.data
          if (res.data.length !== 0) {
            this.all = res.data[0].totalCount
          } else {
            this.all = 0
          }
          this.loading = true
        }
      })
    },
    approve(row) {
      this.$confirm('确认通过该用户的发起人申请？', '提示', {type: 'warning'}).then(() => {
        organizerApplyAudit('id=' + row.id + '&status=2').then(res => {
          if (res) {
            this.queryApply()
            this.$message({showClose: true, message: '已通过', type: 'success'})
          }
        })
      }).catch(() => {})
    },
    rejectButton(row) {
      this.rejectId = row.id
      this.auditNote = ''
      this.rejectPage = true
    },
    reject() {
      if (!this.auditNote || !this.auditNote.trim()) {
        this.$message.error('驳回时必须填写驳回原因')
        return
      }
      organizerApplyAudit('id=' + this.rejectId + '&status=3&auditNote=' + encodeURIComponent(this.auditNote)).then(res => {
        if (res) {
          this.rejectPage = false
          this.queryApply()
          this.$message({showClose: true, message: '已驳回', type: 'success'})
        }
      })
    },
    queryUserList() {
      let subData = 'currPage=' + this.userCurrentPage
          + '&pageSizePara=' + this.userPagesize
          + '&name=' + this.userSearch
      queryUser(subData).then(res => {
        if (res) {
          this.userList = res.data
          if (res.data.length !== 0) {
            this.userAll = res.data[0].totalCount
          } else {
            this.userAll = 0
          }
        }
      })
    },
    setCertified(row) {
      this.$confirm('确认将「' + (row.name || row.wechatPhone) + '」设为认证发起人？（线下合作机构直接开通）', '提示', {type: 'warning'}).then(() => {
        organizerToggle('id=' + row.id + '&organizerStatus=2').then(res => {
          if (res) {
            this.queryUserList()
            this.$message({showClose: true, message: '已设为认证发起人', type: 'success'})
          }
        })
      }).catch(() => {})
    },
    cancelCertified(row) {
      this.$confirm('确认取消「' + (row.name || row.wechatPhone) + '」的认证发起人资格？', '提示', {type: 'warning'}).then(() => {
        organizerToggle('id=' + row.id + '&organizerStatus=0').then(res => {
          if (res) {
            this.queryUserList()
            this.$message({showClose: true, message: '已取消认证', type: 'success'})
          }
        })
      }).catch(() => {})
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    handleSizeChange(val) {
      this.pagesize = val
    },
    handleUserCurrentChange(val) {
      this.userCurrentPage = val
    },
    handleUserSizeChange(val) {
      this.userPagesize = val
    },
  },
  created() {
    this.queryApply();
  },
  watch: {
    currentPage: function () {
      this.queryApply()
    },
    pagesize: function () {
      this.queryApply()
    },
    userCurrentPage: function () {
      this.queryUserList()
    },
    userPagesize: function () {
      this.queryUserList()
    },
  }
}
</script>

<style scoped>
</style>
